export function formatMaintenanceListDate(value: string | null | undefined): string {
  if (!value) {
    return '—';
  }
  const dateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (dateOnly) {
    const year = Number(dateOnly[1]);
    const month = Number(dateOnly[2]);
    const day = Number(dateOnly[3]);
    return new Date(year, month - 1, day).toLocaleDateString('de-DE');
  }
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return value.slice(0, 10);
  }
  return parsed.toLocaleDateString('de-DE');
}

export function maintenanceSortValue(sortBy: string, sortOrder: string): string {
  return `${sortBy}:${sortOrder}`;
}

/** `setSearch` reads a query string. A full path would swallow the first parameter. */
export function maintenanceSearchFromPath(href: string): string {
  const queryIndex = href.indexOf('?');
  return queryIndex >= 0 ? href.slice(queryIndex) : '';
}

export function nextMaintenanceColumnSort<T extends string>(
  current: { sortBy: T; sortOrder: 'asc' | 'desc' },
  sortBy: T,
): { sortBy: T; sortOrder: 'asc' | 'desc' } {
  if (current.sortBy === sortBy) {
    return { sortBy, sortOrder: current.sortOrder === 'asc' ? 'desc' : 'asc' };
  }
  return { sortBy, sortOrder: 'asc' };
}

export function parseMaintenanceSortValue(
  value: string,
): { sortBy: string; sortOrder: 'asc' | 'desc' } | null {
  const separator = value.indexOf(':');
  if (separator <= 0) {
    return null;
  }
  const sortBy = value.slice(0, separator);
  const sortOrder = value.slice(separator + 1);
  if (sortOrder !== 'asc' && sortOrder !== 'desc') {
    return null;
  }
  return { sortBy, sortOrder };
}
